export default __webpack_public_path__ + "static/logo-white-b1d15caf2ee3553c255f5df5f635190c.svg";